import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = ($scope, $filter, $translate, claimViewModel, ViewModelService, ModalService) => {
    const ctrl = Object.create(BaseCtrl);

    ctrl.init = () => {
        $scope.claimVm = ViewModelService.create(
            claimViewModel().value,
            'cc', 'edge.capabilities.claim.fnol.dto.FnolDTO', {
                'InjuryDetailsValidation': true
            }
        );
    };

    ctrl.addBodyPartDetails = () => {
        $scope.claimVm.lobs.workersComp.value.addBodyPartDetails();
    };

    ctrl.removeBodyPartDetails = (bodyPart, index) => {
        ModalService.showWarning(
            'fnol.wc.views.injury.Remove Body Injury',
            $translate('fnol.wc.views.injury.Are you sure you want to remove Body Injury #{{bodyPartDetail}}?', {
                bodyPartDetail: index
            }),
            null,
            $filter('translate')('fnol.wc.views.injury.Remove')
        ).result.then(() => $scope.claimVm.lobs.workersComp.value.removeBodyPartDetails(bodyPart.value));
    };

    ctrl.next = (nextFn) => {
        nextFn($scope.claimVm);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$filter', '$translate', 'claimViewModel', 'ViewModelService', 'ModalService'];

export default fn;
